module.exports = __webpack_public_path__ + "img/calendar.8b6ed286.svg";